import { render, staticRenderFns } from "./TeacherSelect.vue?vue&type=template&id=dafcbf80"
import script from "./TeacherSelect.vue?vue&type=script&lang=js"
export * from "./TeacherSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports